<div class="confirm-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-content">
      <div class="header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <path d="m9 11 3 3L22 4"></path>
        </svg>
      </div>
      <div class="header-text">
        <h2 class="dialog-title">{{ dialogTitle }}</h2>
        <p class="dialog-subtitle">{{ dialogSubtitle }}</p>
      </div>
    </div>
    <button class="close-btn" (click)="onCancel()" type="button" aria-label="Close dialog">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  </div>

  <!-- Dialog Body -->
  <div class="dialog-body">
    <!-- Transfers Summary -->
    <div class="summary-section">
      <div class="summary-header">
        <h3 class="summary-title">{{ summaryTitle }}</h3>
        <div class="summary-badges">
          <span class="badge badge-primary">{{ totalTransfers }} {{ itemLabel }}<span *ngIf="totalTransfers !== 1">s</span></span>
          <span class="badge badge-secondary">{{ totalQuantity }} Total Mats</span>
        </div>
      </div>

      <!-- Transfers List (Read-only) -->
      <div class="transfers-list">
        <div *ngFor="let transfer of data.transfers" class="transfer-item">
          <div class="transfer-icon">
            <!-- Transfer arrows icon for transfers, package icon for direct updates -->
            <svg *ngIf="mode === 'transfer'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m16 3 4 4-4 4"></path>
              <path d="M20 7H4"></path>
              <path d="m8 21-4-4 4-4"></path>
              <path d="M4 17h16"></path>
            </svg>
            <svg *ngIf="mode === 'direct-update'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/>
              <path d="M12 22V12"/><polyline points="3.29 7 12 12 20.71 7"/><path d="m7.5 4.27 9 5.15"/>
            </svg>
          </div>
          <div class="transfer-details">
            <div class="transfer-route">
              <span class="hub-name">{{ transfer.fromHub }}</span>
              <ng-container *ngIf="mode === 'transfer'">
                <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
                <span class="hub-name">{{ transfer.toHub }}</span>
              </ng-container>
            </div>
            <div class="transfer-meta">
              <span class="mat-type-badge" [class.poly]="transfer.matType === 'Poly'" [class.wood]="transfer.matType === 'Wood'">
                {{ transfer.matType }}
              </span>
              <span class="qty-text">{{ transfer.qty }} mats</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirmation Form -->
    <form [formGroup]="confirmForm" class="confirmation-form">
      <!-- Error Message -->
      <div *ngIf="errorMessage" class="error-alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m15 9-6 6"></path>
          <path d="m9 9 6 6"></path>
        </svg>
        {{ errorMessage }}
      </div>

      <!-- Reason Code (only for direct-update mode) -->
      <ng-container *ngIf="mode === 'direct-update'">
        <div class="form-field">
          <label for="reasonCode" class="field-label">
            Reason Code <span class="required">*</span>
          </label>
          <select 
            id="reasonCode" 
            formControlName="reasonCode" 
            class="field-select"
            [class.invalid]="confirmForm.get('reasonCode')?.invalid && confirmForm.get('reasonCode')?.touched">
            <option value="">Select a reason...</option>
            <option *ngFor="let reason of directUpdateReasons" [value]="reason.Code">
              {{ reason.Description }}
            </option>
          </select>
          <div *ngIf="confirmForm.get('reasonCode')?.invalid && confirmForm.get('reasonCode')?.touched" class="field-error">
            Reason code is required
          </div>
        </div>
      </ng-container>

      <!-- Reason Details (Optional, only for direct-update mode) -->
      <div *ngIf="mode === 'direct-update'" class="form-field">
        <label for="reasonDetails" class="field-label">
          Reason Details <span class="optional">(Optional)</span>
        </label>
        <textarea 
          id="reasonDetails" 
          formControlName="reasonDetails" 
          class="field-textarea"
          rows="3"
          placeholder="Add any additional details or notes..."></textarea>
        <div class="field-hint">Provide additional context if needed</div>
      </div>

      <!-- Reason (Optional, only for transfer mode) -->
      <div *ngIf="mode === 'transfer'" class="form-field">
        <label for="transferReason" class="field-label">
          Reason <span class="optional">(Optional)</span>
        </label>
        <textarea 
          id="transferReason" 
          formControlName="reasonDetails" 
          class="field-textarea"
          rows="2"
          placeholder="Why are you transferring these mats?"></textarea>
      </div>
    </form>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isProcessing">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()" [disabled]="isProcessing || confirmForm.invalid">
      <span *ngIf="!isProcessing" class="btn-content">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <path d="m9 11 3 3L22 4"></path>
        </svg>
        {{ confirmButtonLabel }}
      </span>
      <span *ngIf="isProcessing" class="btn-content">
        <span class="spinner"></span>
        {{ confirmingLabel }}
      </span>
    </button>
  </div>
</div>
